/**
 * Research Brief Lab Lesson
 * Skill Area: Insight
 * Transform raw notes into shareable insights
 */

import type { LessonDefinition } from '../types';
import {
  RESEARCH_BRIEF_AI_PROMPT,
  RESEARCH_BRIEF_CONTEXT_SCENARIOS,
} from '../prompts/research-brief-lab.prompt';

export const researchBriefLab: LessonDefinition = {
  id: 'research-brief-lab',
  title: 'Research Brief Lab',
  displayTitle: 'Transform Raw Notes into Shareable Insights',
  subTitle: 'Tidy findings into a shareable brief.',
  tagline: 'Turn raw discovery notes into a crisp brief.',
  persona: 'Lyra',
  skillArea: 'Insight',
  format: 'guided_chat',
  difficulty: 'Intermediate',
  estimatedMinutes: 8,
  tags: ['research', 'analysis', 'insights'],
  dailyEligible: true,
  releasedAt: '2025-02-18T00:00:00.000Z',
  route: '/micro/research-brief-lab',
  storyBeat: 'Lyra organizes interviews, tags, and takeaways automatically.',
  contextTitle: 'Research starter',
  contextSummary:
    'Pick the option closest to your situation. Lyra will pull out what matters and format it so others can understand it fast.',
  contextScenarios: RESEARCH_BRIEF_CONTEXT_SCENARIOS,
  introPrompt:
    "Scattered notes don't travel well. I'll explain why structure matters, show you a before/after, and help you organized your findings.",
  steps: [
    'Select who needs to see these findings',
    'See a "Raw Notes vs. Structured Brief" comparison',
    'Paste your notes to get a clear summary',
  ],
  promptGuidance: 'Choose an audience below or type your own.',
  aiPrompt: RESEARCH_BRIEF_AI_PROMPT,
  inputPlaceholder: "Type 'Board' or your own audience...",
  quickPrompts: ['The Board', 'Program Team', 'A Funder'],
};
